import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { DragSource } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'
import cx from 'classnames'

import { DND_TYPE } from '../../../../../../../../../../dnd/constants'

import './style.scss'

const entitySource = {
    beginDrag: (props) => ({
        entity: props.entity,
    }),
}

function collect(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging(),
    }
}

@DragSource(DND_TYPE.ENTITY, entitySource, collect)
export default class TrGroupComponent extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        connectDragPreview: PropTypes.func.isRequired,
        connectDragSource: PropTypes.func.isRequired,
        entity: IPropTypes.record,
    }

    static defaultProps = {
        entity: null,
    }

    componentDidMount() {
        const { connectDragPreview } = this.props

        connectDragPreview(getEmptyImage())
    }

    render() {
        const { children, entity, connectDragSource } = this.props

        const content = <div className={cx('rt-tr-group', !entity && 'empty')}>{children}</div>

        return entity ? connectDragSource(content) : content
    }
}
